module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-filter"
  }, [_c('div', {
    staticClass: "table-filter-label"
  }, [_vm._v("SEARCH")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    ref: "filter",
    staticClass: "form-control table-filter-input",
    attrs: {
      "type": "text",
      "placeholder": "Enter text to filter"
    },
    domProps: {
      "value": (_vm.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    class: {
      'input-group-addon': true, 'primary': _vm.value.length > 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.reset()
      }
    }
  }, [_c('i', {
    staticClass: "pg-close_line"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25ec274c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/table_filter.vue
// module id = 1288
// module chunks = 1